import { IEntertainmentVenue } from '@shared/shared/interfaces/entertainment-event.interfaces';
import * as UrlLib from '@shared/utils/url.lib';
import * as entertainmentEventVenueActions from '../actions/entertainment-event-venues.actions';

export interface SelectedVenue extends IEntertainmentVenue {
  loaded: boolean;
  loading: boolean;
}
export interface VenuesList {
  venues: Array<IEntertainmentVenue>;
  loaded: boolean;
  loading: boolean;
}
export interface EntertainmentEventVenuesState {
  selected_venue: SelectedVenue;
  venues_list: VenuesList;
}

export const initialState: EntertainmentEventVenuesState = {
  selected_venue: {
    url: '',
    id: 0,
    accessibility_description: '',
    address_line1: '',
    address_line2: '',
    city: '',
    country: '',
    images: [],
    latitude: 0,
    location: '',
    longitude: 0,
    name: '',
    postcode: '',
    seat_plan_file: '',
    seat_plan_image: '',
    state: '',
    loaded: false,
    loading: false,
  },
  venues_list: {
    loaded: false,
    loading: false,
    venues: [],
  },
};

export function reducer(
  state = initialState,
  action: entertainmentEventVenueActions.EntertainmentEventVenuesAction
): EntertainmentEventVenuesState {
  switch (action.type) {
    case entertainmentEventVenueActions.GET_ALL_VENUES: {
      return {
        ...state,
        venues_list: {
          ...state.venues_list,
          loading: true,
        },
      };
    }

    case entertainmentEventVenueActions.GET_ALL_VENUES_SUCCESS: {
      const venues = action.payload.results.map((venue) => {
        return Object.assign({}, venue, {
          venue_id: UrlLib.extractId(venue.venue.url),
          next_performance: {
            ...venue.next_performance,
            id: UrlLib.extractId(venue.next_performance.url),
          },
        });
      });

      return {
        ...state,
        venues_list: {
          venues: venues,
          loading: false,
          loaded: true,
        },
      };
    }

    case entertainmentEventVenueActions.GET_ALL_VENUES_FAIL: {
      return {
        ...state,
        venues_list: {
          venues: state.venues_list.venues,
          loaded: false,
          loading: false,
        },
      };
    }

    case entertainmentEventVenueActions.GET_INDIVIDUAL_VENUE: {
      const selectedVenue = state.venues_list.venues.filter((venue) => venue['venue_id'] === action.payload)[0][
        'venue'
      ];

      return {
        ...state,
        selected_venue: {
          ...state.selected_venue,
          ...selectedVenue,
          id: action.payload,
        },
      };
    }
    default:
      return state;
  }
}

export const getVenuesList = (state: EntertainmentEventVenuesState) => state.venues_list;
export const getSelectedVenue = (state: EntertainmentEventVenuesState) => state.selected_venue;
